<template>
    <el-dropdown @command="handleCommand">
        <span class="avatar-dropdown">
            <!--<el-avatar class="user-avatar" :src="avatar"></el-avatar>-->
            <span class="user_name">{{ displayName }}</span>
            <el-avatar class="user" :size="size" :src="avatarSrc" />
        </span>

        <template #dropdown>
            <el-dropdown-menu>
                <el-dropdown-item command="lang-zh">中文</el-dropdown-item>
                <el-dropdown-item command="lang-en">English</el-dropdown-item>
                <el-dropdown-item command="logout" divided>{{ t('logout') }}</el-dropdown-item>
            </el-dropdown-menu>
        </template>
    </el-dropdown>
</template>

<script setup>
import { ref, defineProps, computed } from "vue";
import { useRouter } from "vue-router";
import { ElMessageBox } from "element-plus";
import {
  clearPortalSession,
  getPortalForCurrentRoute,
  PORTAL_PLATFORM,
  PORTAL_TENANT,
} from "@/utils/authSession";
import { getLoginUserDisplayName, getLoginUser, resolveUserAvatarUrl } from "@/utils/loginUser";
import { setAppLocale, t } from "@/locale/index.js";
const router = useRouter();

const props = defineProps({
  user: {
    type: Object,
    default: () => ({})
  },
});

const size = ref(40);

const displayName = computed(() => getLoginUserDisplayName(props.user))

const avatarSrc = computed(() => {
    const u = props.user?.username || props.user?.realName || props.user?.real_name
        ? props.user
        : getLoginUser()
    return resolveUserAvatarUrl(u)
})

const handleCommand = (command) => {
    switch (command) {
        case 'lang-zh':
            setAppLocale('zh-CN')
            window.location.reload()
            break
        case 'lang-en':
            setAppLocale('en-US')
            window.location.reload()
            break
        case 'logout':
            logout()
            break
    }
}

const logout = () => {
    ElMessageBox.confirm(
        `您确定要退出登录吗?`,
        '提示',
        {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
        }
    )
        .then(() => {
            const portal = getPortalForCurrentRoute()
            clearPortalSession(portal)
            router.push({
                path: portal === PORTAL_PLATFORM ? '/superadmin/login' : '/login'
            })
        })
        .catch(() => {

        })
}
</script>
<style lang="scss" scoped>
.avatar-dropdown {
    display: flex;
    align-content: center;
    align-items: center;
    justify-content: center;
    justify-items: center;
    height: 50px;
    padding: 0;

    .user-avatar {
        width: 40px;
        height: 40px;
        cursor: pointer;
        border-radius: 50%;
    }

    .user-name {
        position: relative;
        margin-left: 5px;
        margin-left: 5px;
        cursor: pointer;
    }
}

.user_name {
  margin-right: 10px;
  color: #333333;
}

.user {
  cursor: pointer;
}

.user_r {
  position: relative;
}

::v-deep .el-dropdown-menu__item--divided {
    border-top: unset;
    margin: 0;
}
</style>
